import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualReplacePage } from './manual-replace.page';

const routes: Routes = [
  {
    path: '',
    component: ManualReplacePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualReplacePageRoutingModule {}
